import { memberPriceMapKey, type PriceMap } from "@/lib/pricing"

/**
 * Member ("at member pricing") figures come solely from Stripe, via the
 * `get-products` feed's `member_price`. `fetchPrices` piggybacks them into the
 * `prices` / `fullPrices` maps under a `member:`-prefixed key (see
 * `memberPriceMapKey`). These helpers read them back so callers don't touch the
 * prefix. CHF-only in practice: the feed is CHF, so EUR markets have no member
 * keys and both helpers return null there (callers already gate on currency).
 */

/** Raw member price in the map's currency (CHF), or null when absent. */
export function memberPriceChf(
  prices: PriceMap,
  key: keyof PriceMap
): number | null {
  const v = prices[memberPriceMapKey(key)]
  return v ? Number(v) : null
}

/** Formatted member price label (e.g. "CHF 45"), or null when absent. Reads the
 *  `fullPrices` map, so it carries the locale-formatted currency. */
export function memberPriceLabelChf(
  fullPrices: PriceMap,
  key: keyof PriceMap
): string | null {
  return fullPrices[memberPriceMapKey(key)] ?? null
}
